import type { Spacing, SpacingSides } from '@sites/entity-core';

/**
 * Updaters for a `spacing` node. A mixin has no fixed key the way a feature
 * does — it is a block's `padding`, a tab body's padding, a row's — so the host
 * form applies these to its own node, through `writeDevice` for a responsive one
 * or `value.update` for a flat one.
 */

/** The four sides live in one leaf, so a single-side edit merges into it. */
export const withSpacingSides =
    (patch: Partial<SpacingSides>) =>
    (current: Spacing | undefined): Spacing =>
        ({ ...current, value: { ...current?.value, ...patch } }) as Spacing;

export const withSpacingUnit =
    (unit: Spacing['unit']) =>
    (current: Spacing | undefined): Spacing =>
        ({ ...current, unit }) as Spacing;
